export enum MarketEnum {
	DK = 'dk',
	US = 'us',
	CASUAL_PLEASURE = 'casualPleasure',
}
